<div class="row row1">
  <div class="col-sm-12 header-container">
    <h2 class="header">Options</h2>
  </div>
</div>
<div class="row row2">
  <div class="col-sm-6 account-details-container">
    <app-manage-payments></app-manage-payments>
    <app-ways-to-pay></app-ways-to-pay>
  </div>
  <div class="col-sm-6 current-bill-container right-page-column">
    <app-billing></app-billing>
  </div>
</div>




// WEBPACK FOOTER //
// ./src/app/options-container/options-container.component.html